<template>
  <section style="width: 100%">
    <div v-for="item in items" :key="item.name" class="ma-0 mb-2">
      <h3>{{ $t(item.name) }}</h3>

      <v-row class="ma-0">
        <v-col
          v-for="(subItem, index) in item.items.slice(0, item.counter)"
          :key="index"
          cols="12"
          sm="6"
          md="4"
        >
          <linked-item :item="subItem"></linked-item>
        </v-col>
      </v-row>

      <v-row v-if="item.items.length > item.counter" class="ma-0" justify="end">
        <v-btn @click="loadMore(item.name)" text color="brand" small>{{
          $t('loadMore')
        }}</v-btn>
      </v-row>
    </div>
  </section>
</template>

<script>
import LinkedItem from './LinkedItem.vue';

export default {
  components: {
    LinkedItem
  },
  props: {
    linkedItems: {
      type: Array,
      required: true
    }
  },

  data: () => ({ items: [] }),

  mounted() {
    this.setItems();
  },

  methods: {
    setItems() {
      this.items = this.linkedItems
        .map(item => {
          const filteredItems = item.items.filter(a => {
            if (item.name === 'linkedProfiles') {
              return a;
            } else {
              return a.available;
            }
          });

          return {
            items: filteredItems,
            counter: 3,
            name: item.name
          };
        })
        .filter(a => a.items.length > 0);
    },

    loadMore(section) {
      const sectionIndex = this.items.findIndex(e => e.name === section);
      this.items[sectionIndex].counter += 3;
    }
  },

  watch: {
    linkedItems() {
      this.setItems();
    }
  }
};
</script>
